/**
 * Thème partagé des sessions QCM cartes (maquette QFlash) — vue scan
 * (ScanMobile) ET projection (Projection/). Source unique des couleurs
 * A-D : les pastilles des choix, les barres de résultats du téléphone et
 * les lettres projetées doivent toujours matcher.
 */

export const QCM_INK = '#12161c';
export const QCM_GREEN = '#22b573';
export const QCM_AMBER = '#f5b83d';

/** Fond bleuté sombre TanoEd — même ambiance que le podium (PodiumQCM). */
export const QCM_NAVY_BG = 'radial-gradient(ellipse at 50% 85%, #1a3a8a 0%, #0d1f4d 40%, #070e24 100%)';

export const LETTRE_HEX = {
  A: '#4f6df5',
  B: '#f0663f',
  C: '#f2b32c',
  D: '#8a5cf6',
};

export const LETTRES = ['A', 'B', 'C', 'D'];

export const FONT_TITRE = "'Archivo', 'Inter', system-ui, sans-serif";
